module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/apiaccesslog/apiaccesslog.html
// module id = 771
// module chunks = 0